<script setup lang="ts">
  import { useGetInnovationTariffEligibility } from "@/api/innovation-tariff/innovation-tariff.ts"
  import { ExternalRoute } from "@/constants/externalRoute"
  import { Route } from "@/constants/route"
  import { useGetAccountId } from "@/lib/useGetAccountId.ts"
  import { useStepWizard } from "@/lib/useStepWizard"
  import { computed } from "vue"
  import { StepWizard } from "@/components/ui/step-wizard"

  const { modelValue } = useStepWizard()

  const customerQuery = useGetAccountId()
  const innovationTariffEligibilityQuery = useGetInnovationTariffEligibility(
    customerQuery.accountId,
  )
  const isEligible = computed(
    () => !!innovationTariffEligibilityQuery.data.value?.isEligible,
  )

  const steps = [
    { route: `${Route.innovationTariff}/${Route.innovationTariffOptions}` },
    { route: `${Route.innovationTariff}/${Route.innovationTariffReview}` },
  ]

  const onLeave = () => {
    window.location.assign(ExternalRoute.websiteHome)
  }
</script>

<template>
  <StepWizard
    v-if="isEligible"
    :initial-step="modelValue"
    :steps="steps"
    title="Your Tariff Options"
    @leave-page="onLeave"
  >
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </StepWizard>
</template>
